import { gql } from '@apollo/client';
export default ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"PaymentObjectPropertyDefinitionFields\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"PropertyDefinition\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"label\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"description\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"groupName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"fieldType\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"formField\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayOrder\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"readOnlyValue\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"readOnlyDefinition\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hidden\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"mutableDefinitionNotDeletable\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"calculated\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"externalOptions\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"externalOptionsReferenceType\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayMode\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"referencedObjectType\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"showCurrencySymbol\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currencyPropertyName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hubspotDefined\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"deleted\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"textDisplayHint\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"numberDisplayHint\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"options\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"label\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayOrder\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"doubleData\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hidden\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"readOnly\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"description\"}}]}}]}}]}", {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "PaymentObjectPropertyDefinitionFields"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "PropertyDefinition"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "name"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "label"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "description"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "groupName"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "type"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "fieldType"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "formField"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "displayOrder"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "readOnlyValue"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "readOnlyDefinition"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "hidden"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "mutableDefinitionNotDeletable"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "calculated"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "externalOptions"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "externalOptionsReferenceType"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "displayMode"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "referencedObjectType"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "showCurrencySymbol"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "currencyPropertyName"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "hubspotDefined"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "deleted"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "textDisplayHint"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "numberDisplayHint"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "objectTypeId"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "options"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "value"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "displayOrder"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "doubleData"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "hidden"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "readOnly"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "description"
            }
          }]
        }
      }]
    }
  }]
});